module.exports = __webpack_public_path__ + "static/image_default-534bdccb32d4ad01f0e8079e0c75ba63.jpg";